const PADDING = 0.1;
const OVER_LOG_10 = 1 / Math.log(10);
/**
 * Calculate the extent max based on min/max value.
 * It will make around 10% padding and keep the value
 * close to whole as possible
 */
export const paddedMax = (min: number, max: number): number => {
  const span = max - min;
  if (!span) {
    return max + Math.abs(max) * PADDING;
  }

  const resolution = span * PADDING;
  // 14 -> 10; 0.8 -> 1; 0.08 -> 0.1
  const resolutionRoundTo10Pow = Math.pow(
    10,
    Math.ceil(Math.log(resolution) * OVER_LOG_10)
  );

  const increased = max + resolution;
  return Math.ceil(increased / resolutionRoundTo10Pow) * resolutionRoundTo10Pow;
};

/**
 * Counterpart of paddedMax().
 */
export const paddedMin = (min: number, max: number): number => {
  return -paddedMax(-max, -min);
};
